/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
import { lazy } from 'src/utils/lazyComp';
import { IRouteProps } from './types';

const adminRouters: IRouteProps[] = [
  {
    path: 'equityUpload',
    title: '名单上传',
    index: false,
    permissionKey: 'ADMIN01',
    icon: 'equityUpload',
    element: lazy(() => import('src/pages/EquityImport')),
  },
  {
    path: 'equityUpload',
    title: '名单上传',
    isFree: true,
    children: [
      {
        path: 'detail',
        title: '详情',
        permissionKey: 'ADMIN0102',
        element: lazy(() => import('src/pages/EquityImport/components/GrantDetail')),
      },
    ],
  },
  {
    path: 'equityDataAdmin',
    title: '白名单数据管理',
    // index: false,
    permissionKey: 'ADMIN02',
    icon: 'equityDataAdmin',
    element: lazy(() => import('src/pages/DataManagement')),
  },
  {
    path: 'equityDataAdmin',
    title: '白名单数据管理',
    isFree: true,
    children: [
      {
        path: 'detail',
        permissionKey: 'ADMIN0202',
        title: '详情',
        cache: false,
        element: lazy(() => import('src/pages/DataManagement/components/DataDetail')),
      },
      {
        path: 'abnormalRecord',
        title: '发放异常记录',
        permissionKey: 'ADMIN0208',
        element: lazy(() => import('src/pages/DataManagement/components/AbnormalRecord')),
      },
      {
        path: 'ressiueRecord',
        title: '补发记录',
        permissionKey: 'ADMIN0207',
        element: lazy(() => import('src/pages/DataManagement/components/RessiueRecord')),
      },
      {
        path: 'deleteRecord',
        title: '删除记录',
        permissionKey: 'ADMIN0210',
        element: lazy(() => import('src/pages/DataManagement/components/DeleteRecord')),
      },
      {
        path: 'bankCardRecord',
        title: '银行卡记录',
        permissionKey: 'ADMIN0214',
        element: lazy(() => import('src/pages/DataManagement/components/BankCardRecord')),
      },
    ],
  },
  {
    path: 'accountAdmin',
    title: '对账结算',
    index: false,
    permissionKey: 'ADMIN03',
    icon: 'accountAdmin',
    element: lazy(() => import('src/pages/AccountAdmin')),
  },
  {
    path: 'statistical-settlement',
    title: '统计汇算',
    // isFree: true,
    icon: 'statistics',
    permissionKey: 'ADMIN08',
    children: [
      {
        path: 'settle-account',
        title: '日资金汇算',
        permissionKey: 'ADMIN0805',
        element: lazy(() => import('../pages/StatisticalSettlement/SettleAccount')),
      },
      {
        path: 'comprehensive-account',
        title: '综合台账汇算',
        permissionKey: 'ADMIN0802',
        element: lazy(() => import('src/pages/StatisticalSettlement/ComprehensiveAccount')),
      },
      {
        path: 'institutional-statistical',
        permissionKey: 'ADMIN0801',
        title: '机构统计汇算',
        element: lazy(() => import('src/pages/StatisticalSettlement/InstitutionalStatistical')),
      },
      {
        path: 'refund',
        permissionKey: 'ADMIN0804',
        title: '回款金额汇算',
        element: lazy(() => import('src/pages/StatisticalSettlement/Refund')),
      },
    ],
  },
  {
    path: 'welcome',
    title: '首页',
    index: false,
    breadcrumb: false,
    isFree: true,
    element: lazy(() => import('src/containers/welcomePage')),
  },

  {
    path: 'activity',
    title: '营销活动管理',
    index: false,
    permissionKey: 'ADMIN0501',
    icon: 'activity',
    children: [
      {
        path: 'cockpit',
        title: '运营驾驶舱',
        permissionKey: 'ADMIN0507',
        element: lazy(() => import('src/pages/activity/activityCockpit')),
      },
      {
        path: 'activityTheme',
        title: '营销活动主题',
        permissionKey: 'ADMIN0501',
        element: lazy(() => import('src/pages/activity/activityTheme')),
      },
      {
        path: 'activityTheme',
        isFree: true,
        children: [
          {
            path: 'templetList',
            title: '模板列表',
            element: lazy(() => import('src/pages/activity/activityTheme/TempletList')),
          },
          {
            path: 'activityList',
            title: '活动类型',
            element: lazy(() => import('src/pages/activity/activityTheme/ActivityList')),
          },
        ],
      },
      {
        path: 'activityManagement',
        title: '活动管理',
        permissionKey: 'ADMIN050101',
        element: lazy(() => import('src/pages/activity/activityManagement/list.js')),
      },
      {
        path: 'activityManagement',
        title: '活动管理',
        isFree: true,
        permissionKey: 'ADMIN0501',
        children: [
          {
            path: 'add',
            title: '新增',
            permissionKey: 'ADMIN0501',
            element: lazy(() => import('src/pages/activity/activityManagement/add')),
          },
          {
            path: 'edit/:id',
            title: '编辑/详情',
            permissionKey: 'ADMIN0501',
            element: lazy(() => import('src/pages/activity/activityManagement/edit')),
          },
          {
            path: 'list',
            title: '活动主题',
            permissionKey: 'ADMIN050101',
            element: lazy(() => import('src/pages/activity/activityManagement/templeList')),
          },
          //宣传类
          {
            path: 'publicizeAdd',
            title: '新增',
            permissionKey: 'ADMIN050101',
            element: lazy(() => import('src/pages/activity/activityManagement/publicizeAdd')),
          },
          //宣传类
          {
            path: 'publicizeEdit/:id',
            title: '编辑/详情',
            permissionKey: 'ADMIN050101',
            element: lazy(() => import('src/pages/activity/activityManagement/publicizeEdit')),
          },
          //答题类
          {
            path: 'answerType',
            title: '活动管理',
            permissionKey: 'ADMIN050101',
            element: lazy(() => import('src/pages/activity/activityManagement/AnswerType')),
          },
          {
            path: 'answerAdd',
            title: '新增',
            permissionKey: 'ADMIN050101',
            element: lazy(() => import('src/pages/activity/activityManagement/answer/add')),
          },
          {
            path: 'answerEdit/:id',
            title: '编辑/详情',
            permissionKey: 'ADMIN050101',
            element: lazy(() => import('src/pages/activity/activityManagement/answer/edit')),
          },
        ],
      },
      {
        path: 'activityRecord',
        title: '活动记录',
        permissionKey: 'ADMIN16',
        element: lazy(() => import('src/pages/activity/historyRecord')),
      },
      {
        path: 'deliveryList',
        title: '活动历史记录',
        permissionKey: 'ADMIN1304',
        element: lazy(() => import('src/pages/sysAdmin/DeliveryList')),
      },
      {
        path: 'deliveryList',
        title: '交付清单管理',
        permissionKey: 'ADMIN1304',
        isFree: true,
        cache: false,
        children: [
          {
            path: 'detail',
            title: '详情',
            cache: false,
            permissionKey: 'ADMIN130403',
            element: lazy(() => import('src/pages/sysAdmin/DeliveryDetail')),
          },
          {
            path: 'edit',
            title: '编辑',
            permissionKey: 'ADMIN130404',
            element: lazy(() => import('src/pages/sysAdmin/DeliveryDetail')),
          },
          {
            path: 'add',
            title: '新增',
            permissionKey: 'ADMIN130402',
            element: lazy(() => import('src/pages/sysAdmin/DeliveryDetail')),
          },
        ],
      },
      {
        path: 'inventory',
        permissionKey: 'ADMIN0803',
        title: '活动交付清单',
        element: lazy(() => import('src/pages/StatisticalSettlement/Inventory')),
      },

      {
        path: 'inventory',
        isFree: true,
        title: '活动交付清单',
        permissionKey: 'ADMIN0803',
        children: [
          {
            path: 'create',
            title: '生成清单',
            permissionKey: 'ADMIN080301',
            element: lazy(() => import('src/pages/StatisticalSettlement/Inventory/Edit')),
          },
          {
            path: 'copy',
            title: '复制清单',
            permissionKey: 'ADMIN080301',
            element: lazy(() => import('src/pages/StatisticalSettlement/Inventory/Edit')),
          },
          {
            path: 'edit',
            title: '编辑清单',
            permissionKey: 'ADMIN080301',
            element: lazy(() => import('src/pages/StatisticalSettlement/Inventory/Edit')),
          },
          {
            path: 'detail',
            title: '清单详情',
            cache: false,
            permissionKey: 'ADMIN0803',
            element: lazy(() => import('src/pages/StatisticalSettlement/Inventory/Detail')),
          },
          {
            path: 'preview',
            title: '清单预览',
            permissionKey: 'ADMIN0803',
            element: lazy(() => import('src/pages/StatisticalSettlement/Inventory/Detail')),
          },
          {
            path: 'operatorConfig',
            title: '清单操作人员配置',
            permissionKey: 'ADMIN0803',
            element: lazy(() => import('src/pages/StatisticalSettlement/Inventory/OperatorConfig')),
          },
        ],
      },
      {
        path: 'templateManagement',
        title: '模板管理',
        permissionKey: 'ADMIN0506',
        element: lazy(() => import('src/pages/activity/TemplateManagement')),
      },
      {
        path: 'templateManagement',
        title: '模板管理',
        isFree: true,
        permissionKey: 'ADMIN0506',
        children: [
          {
            path: 'add',
            title: '新增',
            element: lazy(
              () => import('src/pages/activity/TemplateManagement/components/AddTemplate'),
            ),
          },
          {
            path: 'edit',
            title: '编辑',
            cache: false,
            element: lazy(
              () => import('src/pages/activity/TemplateManagement/components/AddTemplate'),
            ),
          },
          {
            path: 'details',
            title: '详情',
            cache: false,
            element: lazy(
              () => import('src/pages/activity/TemplateManagement/components/AddTemplate'),
            ),
          },
        ],
      },
      {
        path: 'record',
        title: '客户抽奖记录',
        permissionKey: 'ADMIN050201',
        element: lazy(() => import('src/pages/activity/LotteryRecord')),
      },
      {
        path: 'chatHistory',
        title: '智能营销记录',
        permissionKey: 'ADMIN0503',
        element: lazy(() => import('src/pages/activity/chatHistory')),
      },
      {
        path: 'question',
        title: '题库',
        permissionKey: 'ADMIN0505',
        element: lazy(() => import('src/pages/activity/question')),
      },
      {
        path: 'allocationVoucherScheme',
        title: '配置券方案',
        permissionKey: 'ADMIN0909',
        element: lazy(() => import('src/pages/activity/allocationVoucherScheme')),
      },
      {
        path: 'couponList',
        title: '优惠券使用记录',
        permissionKey: 'ADMIN0911',
        element: lazy(() => import('src/pages/activity/couponList')),
      },
      {
        path: 'pointsList',
        title: '积分兑换管理',
        permissionKey: 'ADMIN0910',
        element: lazy(() => import('src/pages/activity/pointsList')),
      },
      {
        path: 'joinRecord',
        title: '活动参与记录',
        isFree: true,
        permissionKey: 'ADMIN040107',
        element: lazy(() => import('src/pages/activity/joinRecord')),
      },
    ],
  },
  {
    path: 'labelAdminSystem',
    title: '标签与模型',
    index: false,
    permissionKey: 'ADMIN11',
    icon: 'label',
    children: [
      {
        path: 'labelAdmin',
        title: '属性管理',
        permissionKey: 'ADMIN1101',
        element: lazy(() => import('src/pages/LabelAdminSys/LabelAdmin')),
      },
      {
        path: 'labelGroupAdmin',
        title: '标签组管理',
        permissionKey: 'ADMIN1102',
        element: lazy(() => import('src/pages/LabelAdminSys/LabelGroupAdmin')),
      },
      {
        path: 'labelGroupAdmin',
        title: '标签组管理',
        isFree: true,
        permissionKey: 'ADMIN1102',
        children: [
          {
            path: 'addTagGroup',
            title: '添加属性组',
            element: lazy(() => import('src/pages/LabelAdminSys/AddTagGroup')),
          },
          {
            path: 'editTagGroup/:id',
            title: '编辑属性组',
            element: lazy(() => import('src/pages/LabelAdminSys/EditTagGroup')),
          },
        ],
      },
      {
        path: 'labelGroupAdmin/detail/:id',
        title: '属性组详情',
        permissionKey: 'ADMIN1102',
        element: lazy(() => import('src/pages/LabelAdminSys/LabelGroupAdmin/Detail')),
        isFree: true,
        cache: false,
      },
      {
        path: 'customerManagement',
        title: '客户管理',
        permissionKey: 'ADMIN1103',
        element: lazy(() => import('src/pages/LabelAdminSys/CustomerManagement')),
      },
      {
        path: 'customerManagement',
        title: '客户管理',
        permissionKey: 'ADMIN1103',
        isFree: true,
        children: [
          {
            path: 'detail',
            title: '客户详情',
            permissionKey: 'ADMIN1103',
            cache: false,
            element: lazy(
              () => import('src/pages/LabelAdminSys/CustomerManagement/CustomerDetail'),
            ),
          },
        ],
      },
    ],
  },
  {
    path: 'proxySystem',
    title: '销售人员管理',
    index: false,
    permissionKey: 'ADMIN09',
    icon: 'agent',
    children: [
      {
        path: 'proxyAccount',
        title: '账号管理',
        permissionKey: 'ADMIN0905',
        element: lazy(() => import('src/pages/proxySystem/proxyAccount')),
      },
      {
        path: 'onlineTraining',
        title: '在线培训',
        permissionKey: 'ADMIN17',
        children: [
          {
            path: 'course',
            title: '培训课程',
            permissionKey: 'ADMIN1703',
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/course/list')),
          },
          {
            path: 'onlineAnswerList',
            title: '在线答题',
            permissionKey: 'ADMIN1701',
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/onlineAnswer/list')),
          },
          {
            path: 'answerList',
            title: '答题卷库',
            permissionKey: 'ADMIN1705',
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/answer/list')),
          },
          {
            path: 'questionBankList',
            title: '题库管理',
            permissionKey: 'ADMIN1702',
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/questionBank/list')),
          },
          {
            path: 'statisticsReport',
            title: '统计报表',
            permissionKey: 'ADMIN1704',
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/statisticsReport')),
          },
          {
            path: 'onlineAnswerDetail',
            title: '答题详情',
            isFree: true,
            cache: false,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/onlineAnswer/detail')),
          },
          {
            path: 'onlineAnswerCreate',
            title: '创建答题',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/onlineAnswer/form')),
          },
          {
            path: 'onlineAnswerEdit',
            title: '编辑答题',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/onlineAnswer/form')),
          },

          {
            path: 'course/add',
            title: '新增课程',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/course/courseAdd')),
          },
          {
            path: 'course/edit',
            title: '编辑课程',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/course/courseAdd')),
          },
          {
            path: 'courseDetail',
            title: '课程详情',
            permissionKey: 'ADMIN170305',
            isFree: true,
            cache: false,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/course/detail')),
          },
          {
            path: 'courseAdd',
            title: '添加课程',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/course/form')),
          },
          {
            path: 'courseEdit',
            title: '编辑课程',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/course/form')),
          },

          {
            path: 'answerAdd',
            title: '创建答题卷',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/answer/form')),
          },
          {
            path: 'answerEdit',
            title: '编辑答题卷',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/answer/form')),
          },
          {
            path: 'answerDetail',
            title: '答题卷详情',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/onlineTraining/answer/detail')),
          },
        ],
      },
      {
        path: 'damageInspection',
        title: '定损复检',
        permissionKey: ['ADMIN091311', 'ADMIN09131101', 'ADMIN091312', 'ADMIN09131201'],
        children: [
          {
            path: 'list',
            title: '定损复检管理',
            permissionKey: 'ADMIN09131101',
            element: lazy(() => import('src/pages/proxySystem/damageInspection/list')),
          },
          {
            path: 'statisticsAnalysis',
            title: '复检统计分析',
            permissionKey: 'ADMIN091312',
            element: lazy(
              () => import('src/pages/proxySystem/damageInspection/statisticsAnalysis'),
            ),
          },
          {
            permissionKey: 'ADMIN09131102',
            path: 'add',
            title: '新增',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/damageInspection/operate')),
          },
          {
            permissionKey: 'ADMIN09131103',
            path: 'edit/:id',
            title: '编辑',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/damageInspection/operate')),
          },
        ],
      },
      {
        path: 'marketingRecords',
        title: '智能营销记录',
        permissionKey: 'ADMIN0912',
        element: lazy(() => import('src/pages/proxySystem/marketingRecords')),
      },
      {
        path: 'policyInformation',
        title: '保单信息管理',
        permissionKey: 'ADMIN0902',
        element: lazy(() => import('src/pages/proxySystem/policyInformation')),
      },
      {
        path: 'statistics',
        title: '数据统计',
        permissionKey: 'ADMIN0901',
        element: lazy(() => import('src/pages/proxySystem/statistics')),
      },
      {
        path: 'products',
        title: '产品管理',
        permissionKey: 'ADMIN0903',
        element: lazy(() => import('src/pages/proxySystem/products')),
      },
      {
        path: 'products',
        title: '产品管理',
        permissionKey: 'ADMIN0903',
        isFree: true,
        children: [
          {
            path: 'add',
            title: '新增',
            // isFree: true,
            element: lazy(() => import('src/pages/proxySystem/products/add')),
          },
          {
            path: 'edit/:id',
            title: '详情',
            // isFree: true,
            element: lazy(() => import('src/pages/proxySystem/products/edit')),
          },
        ],
      },
      {
        path: 'task-manage',
        title: '任务管理',
        permissionKey: 'ADMIN0904',
        element: lazy(() => import('src/pages/proxySystem/taskManage')),
      },
      {
        path: 'task-manage',
        title: '任务管理',
        isFree: true,
        permissionKey: 'ADMIN0904',
        children: [
          {
            path: 'editor',
            title: '新增任务',
            isFree: true,
            element: lazy(() => import('src/pages/proxySystem/taskManage/Editor')),
          },
        ],
      },
      {
        path: 'receiveAdmin',
        title: '投放管理',
        permissionKey: 'ADMIN0900',
        children: [
          {
            path: 'customerReceive',
            title: '客户投放管理',
            permissionKey: 'ADMIN0906',
            element: lazy(() => import('src/pages/proxySystem/customerReceive')),
          },
          {
            path: 'customerReceive',
            title: '客户投放管理',
            permissionKey: 'ADMIN0906',
            isFree: true,
            children: [
              {
                path: 'detail',
                title: '详情',
                permissionKey: 'ADMIN0906',
                element: lazy(
                  () => import('src/pages/proxySystem/customerReceive/components/DataDetail'),
                ),
              },
              {
                path: 'abnormalRecord',
                title: '发放异常记录',
                permissionKey: 'ADMIN090607',
                element: lazy(
                  () => import('src/pages/proxySystem/customerReceive/components/AbnormalRecord'),
                ),
              },
              {
                path: 'ressiueRecord',
                title: '补发记录',
                permissionKey: 'ADMIN090606',
                element: lazy(
                  () => import('src/pages/proxySystem/customerReceive/components/RessiueRecord'),
                ),
              },
            ],
          },
          {
            path: 'orders',
            title: '投放订单管理',
            permissionKey: 'ADMIN0907',
            element: lazy(() => import('src/pages/proxySystem/orders')),
          },
        ],
      },
    ],
  },
  {
    path: 'serviceProviderManage',
    title: '服务商管理',
    icon: 'channelSetting',
    permissionKey: 'ADMIN18',
    children: [
      {
        path: 'channelConfig',
        title: '通道配置',
        cache: false,
        permissionKey: 'ADMIN1801',
        element: lazy(() => import('src/pages/competitorAdmin/ChannelConfig')),
      },
      {
        path: 'settingConfig',
        title: '配置通道',
        isFree: true,
        cache: false,
        permissionKey: 'ADMIN1803',
        element: lazy(() => import('src/pages/competitorAdmin/SettingConfig')),
      },
      {
        path: 'historyAuthRecord',
        title: '历史授权记录',
        isFree: true,
        cache: false,
        permissionKey: 'ADMIN1804',
        element: lazy(() => import('src/pages/competitorAdmin/HistoryAuthRecord')),
      },
    ],
  },
  {
    path: 'supplierManagement',
    title: '供应商管理',
    icon: 'configuration',
    permissionKey: 'SUPPLIER',
    children: [
      {
        path: 'supplierList',
        title: '供应商管理',
        permissionKey: 'SUPPLIER0101',
        element: lazy(() => import('src/pages/supplierManagement/supplierList')),
      },
      {
        path: 'supplierList',
        title: '供应商管理',
        permissionKey: 'SUPPLIER0101',
        isFree: true,
        children: [
          {
            path: 'detail',
            title: '详情',
            permissionKey: 'SUPPLIER0102',
            element: lazy(() => import('src/pages/supplierManagement/supplierList/detail')),
          },
        ],
      },
      {
        path: 'overview',
        title: '总览',
        cache: false,
        permissionKey: 'SUPPLIER02',
        element: lazy(() => import('src/pages/supplierManagement/overview')),
      },
      // {
      //   path: 'accountAdmin',
      //   title: '对账结算',
      //   index: false,
      //   permissionKey: 'SUPPLIER0703',
      //   // icon: 'accountAdmin',
      //   element: lazy(() => import('src/pages/supplierManagement/AccountAdmin')),
      // },
      {
        path: 'orders',
        title: '订单管理',
        permissionKey: 'SUPPLIER03',
        cache: false,
        element: lazy(() => import('src/pages/supplierManagement/orders/list')),
      },
      {
        path: 'equityPayment',
        title: '权益交付记录',
        permissionKey: 'SUPPLIER04',
        element: lazy(() => import('src/pages/supplierManagement/equityPayment')),
      },
      {
        path: 'equityPaymentConfirm',
        title: '权益支付确认',
        permissionKey: 'SUPPLIER07',
        element: lazy(() => import('src/pages/supplierManagement/equityPaymentConfirm')),
      },
      {
        path: 'orders/purchasing',
        title: '订购',
        isFree: true,
        permissionKey: 'SUPPLIER0302',
        element: lazy(() => import('src/pages/supplierManagement/orders/purchasing')),
      },
      {
        path: 'buyer',
        title: '管理采购单位',
        isFree: true,
        permissionKey: 'SUPPLIER06',
        element: lazy(() => import('src/pages/supplierManagement/orders/buyer')),
      },
      {
        path: 'userManagement',
        title: '用户管理',
        permissionKey: 'SUPPLIER05',
        element: lazy(() => import('src/pages/supplierManagement/userManagement')),
      },
    ],
  },
  {
    path: 'equityImport',
    title: '经代管理',
    index: false,
    permissionKey: 'ADMIN06',
    icon: 'equityImport',
    children: [
      // TODO:废弃
      {
        path: 'equityImportVerifyProxy',
        title: '名单上传',
        permissionKey: 'ADMIN0601',
        element: lazy(() => import('src/pages/EquityImportProxy')),
      },
      // TODO:废弃
      {
        path: 'equityImportVerifyProxy',
        title: '名单上传',
        permissionKey: 'ADMIN0601',
        isFree: true,
        children: [
          {
            path: 'detail',
            title: '详情',
            permissionKey: 'ADMIN060102',
            element: lazy(() => import('src/pages/EquityImportProxy/components/GrantDetail')),
          },
        ],
      },
      {
        path: 'accountAdminProxy',
        title: '对账管理',
        permissionKey: 'ADMIN0602',
        element: lazy(() => import('src/pages/AccountAdminProxy')),
      },
      {
        path: 'accountAdminProxy',
        title: '对账管理',
        permissionKey: 'ADMIN0602',
        isFree: true,
        children: [
          {
            path: 'record',
            title: '导入记录',
            permissionKey: 'ADMIN060204',
            element: lazy(() => import('src/pages/AccountAdminProxy/components/ImportRecord')),
          },
          {
            path: 'record',
            title: '导入记录',
            permissionKey: 'ADMIN060204',
            isFree: true,
            children: [
              {
                path: 'detail',
                title: '详情',
                permissionKey: 'ADMIN060204',
                element: lazy(() => import('src/pages/AccountAdminProxy/components/ImportDetail')),
              },
            ],
          },
        ],
      },
    ],
  },

  // {
  //   path: 'messageCenter',
  //   title: '消息中心',
  //   isFree: true,
  //   element: lazy(() => import('src/pages/MessageInfoAdmin')),
  // },
  {
    path: 'dataView',
    title: '数据视图',
    index: false,
    breadcrumb: false,
    permissionKey: 'ADMIN07',
    icon: 'dataView',
    element: lazy(() => import('src/pages/dataView')),
  },
  {
    path: 'account',
    title: '用户管理',
    index: false,
    permissionKey: 'ADMIN04',
    icon: 'account',
    children: [
      {
        path: 'frontUserManage',
        title: '前台用户管理',
        permissionKey: 'ADMIN040101',
        element: lazy(() => import('src/pages/account/frontUser')),
      },
      {
        path: 'frontUserManage',
        title: '前台用户管理',
        permissionKey: 'ADMIN040101',
        isFree: true,
        children: [
          {
            path: 'detail',
            title: '用户详情',
            // permissionKey: 'ADMIN040107',
            cache: false,
            element: lazy(() => import('src/pages/account/frontUser/components/UserDetail')),
          },
        ],
      },
      {
        path: 'adminUserManage',
        title: '后台用户管理',
        permissionKey: 'ADMIN040201',
        element: lazy(() => import('src/pages/account/adminUser')),
      },
      {
        path: 'roleManage',
        title: '角色管理',
        permissionKey: 'ADMIN040301',
        element: lazy(() => import('src/pages/account/roleManage')),
      },
      {
        path: 'roleManage',
        title: '角色管理',
        isFree: true,
        permissionKey: 'ADMIN0403',
        children: [
          {
            path: 'add',
            title: '新增',
            permissionKey: 'ADMIN040302',
            element: lazy(() => import('src/pages/account/roleManage/add.jsx')),
          },
          {
            path: 'edit/:id',
            title: '编辑',
            cache: false,
            permissionKey: 'ADMIN040303',
            element: lazy(() => import('src/pages/account/roleManage/edit.jsx')),
          },
        ],
      },
      {
        path: 'departmentManage',
        title: '机构管理',
        permissionKey: 'ADMIN040903',
        element: lazy(() => import('src/pages/account/departmentManage')),
      },
    ],
  },
  {
    path: 'sys',
    title: '系统管理',
    icon: 'sysAdmin',
    breadcrumb: false,
    permissionKey: 'ADMIN13',
    children: [
      {
        path: 'rebateSetting',
        title: '立减金配置',
        permissionKey: 'ADMIN130601',
        element: lazy(() => import('src/pages/sysAdmin/rebateSetting')),
      },
      {
        path: 'orgQuotaManage',
        title: '机构设置',
        permissionKey: 'ADMIN1301',
        element: lazy(() => import('src/pages/account/orgQuotaManage')),
      },
      {
        path: 'projectSetting',
        title: '项目设置',
        permissionKey: 'ADMIN20',
        element: lazy(() => import('src/pages/sysAdmin/ProjectSetting')),
      },
      {
        path: 'domainSetting',
        title: '域名设置',
        permissionKey: 'ADMIN0407',
        element: lazy(() => import('src/pages/sysAdmin/DomainSetting')),
      },
      {
        path: 'backDomainSetting',
        title: '后台域名设置',
        permissionKey: 'ADMIN0407',
        isFree: true,
        element: lazy(() => import('src/pages/sysAdmin/BackDomainSetting')),
      },
      // {
      //   path: 'blackList',
      //   title: '导入黑名单',
      //   permissionKey: 'ADMIN0408',
      //   element: lazy(() => import('src/pages/sysAdmin/BlackList')),
      // },
      {
        path: 'authAndBlackList',
        title: '导入授信与拉黑',
        permissionKey: 'ADMIN0410',
        element: lazy(() => import('src/pages/sysAdmin/AuthAndBlackList')),
      },
      {
        path: 'proxyProduct',
        title: '经代产品配置',
        isFree: true,
        permissionKey: 'ADMIN040705',
        element: lazy(
          () => import('src/pages/sysAdmin/DomainSetting/components/ProxyProductSetting'),
        ),
      },

      {
        path: 'systemManage',
        title: '系统设置',
        permissionKey: 'ADMIN1302',
        element: lazy(() => import('src/pages/account/systemManage')),
      },
      {
        path: 'logManager',
        title: '日志管理',
        permissionKey: 'ADMIN0406',
        element: lazy(() => import('src/pages/account/logManager')),
      },
      //  只有root账号才能有缓存配置权限
      {
        path: 'cacheConfig',
        title: '缓存配置',
        permissionKey: 'ADMIN130201',
        adminType: 'ROOT',
        element: lazy(() => import('src/pages/sysAdmin/CacheConfig')),
      },
      {
        path: 'statistics',
        title: '数据统计',
        // permissionKey: 'ADMIN1304',
        isFree: true,
        element: lazy(() => import('src/pages/sysAdmin/Statistics')),
      },
    ],
  },
  {
    path: 'bankEquity',
    title: '银行权益',
    index: false,
    isFree: true, //屏蔽此菜单
    // permissionKey: "ADMIN06",
    icon: 'icon-chanyeyanjiu',
    children: [
      {
        path: 'orderData',
        title: '银行权益订单数据',
        permissionKey: 'ADMIN0601',
        element: lazy(() => import('src/pages/BankEquity/BankOrderData')),
      },
    ],
  },
];

export default adminRouters;
